import { formatNumber } from '@/lib/format';
/**
 * The values a tag's files disagree on, each quoted (a value can itself hold brackets, or read
 * "<empty>") with how many files hold it: “Equine (Horse)” in 2,507, empty in 1.
 */
export function variesSummary(varies, t) {
    return varies
        .map((v) => v.value === ''
        ? t('tagEditor.hint.variesEmpty', { number: formatNumber(v.files) })
        : t('tagEditor.hint.variesValue', { value: v.value, number: formatNumber(v.files) }))
        .join(', ');
}
/** A count for a plural string that prints it as {{number}}: chosen by count, grouped for the locale. */
export function counted(count) {
    return { count, number: formatNumber(count) };
}
